const excludedFields = [
  "status",
  "relativeLGS",
  "relativeClient",
  "positionApplied",
  "newStartDateTime",
  "newEndDateTime",
  "area",
  "coordinator",
  "onBoardDate",
  "onBoardStartTime",
  "onBoardEndTime",
  "hireStartDate",
  "hireEndDate",
  "applicant",
  "referenceNumber",
  "recruiter",
  "interviewCoordinator",
  "window",
  "reason",
  "startDate",
  "endDate",
  "servedBy",
];

export default excludedFields;
